var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 91,
    viewBox: "0 0 98 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2069 77.5185V84.268C64.2069 87.9973 61.1849 91 57.457 91H6.74991C3.01071 91 0 87.971 0 84.2346V6.76545C0 3.02773 3.03884 0 6.78745 0H40.5517V20.2286C40.5517 23.9744 43.5866 26.963 47.3303 26.963H64.2069V33.7037H33.8162C28.2044 33.7037 23.6552 38.2276 23.6552 43.8107V67.4115C23.6552 72.9935 28.1699 77.5185 33.8162 77.5185H64.2069ZM43.931 0V20.2123C43.931 22.0792 45.455 23.5926 47.2792 23.5926H64.2069L43.931 0ZM33.7747 37.0741C30.0522 37.0741 27.0345 40.108 27.0345 43.7879V67.4343C27.0345 71.1423 30.0838 74.1481 33.7747 74.1481H91.2598C94.9823 74.1481 98 71.1142 98 67.4343V43.7879C98 40.08 94.9507 37.0741 91.2598 37.0741H33.7747ZM51.552 45.54V48.144H43.292V53.884H49.732V56.488H43.292V65H40.1V45.54H51.552ZM57.7022 65V45.54H54.5102V65H57.7022ZM65.085 62.424H71.665V65H61.893V45.54H65.085V62.424ZM77.5264 53.828V48.116H85.0864V45.512H74.3344V65H85.0864V62.396H77.5264V56.432H84.2464V53.828H77.5264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.99b5ebe7a0ed427a53b6f945da226b86.svg";
export { ForwardRef as ReactComponent };